import { useEffect, useState } from 'react'
import { fetchAdvanceCompany, fetchSalesAccountsReceivable, fetchSalesPayment } from '@/apis/aipass'
import { PaymentSettingType } from '@/models/sales'
import { AccountsReceivableSettingType } from '@/models/accounts-receivable'
import { AdvanceCompanyType } from '@/models/sales-manager/advance-money'

/**
 * 入金フォーム（AdjustmentPaymentForm）の選択肢に使うマスタを取得する。
 * 予約詳細画面は useReservationDetailSalesMasters でまとめて取得するため、これは売上管理画面の取引詳細で使う。
 */
export const useAdjustmentPaymentMasters = () => {
  const [advanceCompany, setAdvanceCompany] = useState<AdvanceCompanyType>({ paymentCompanies: [], paymentMethod: [] })
  const [salesPayments, setSalesPayments] = useState<PaymentSettingType[]>([])
  const [accountsReceivableSettings, setAccountsReceivableSettings] = useState<AccountsReceivableSettingType[]>([])
  const [isMastersLoaded, setIsMastersLoaded] = useState<boolean>(false)

  // 残高（currentBalance）は精算で変わりうるが、画面を開いたときの値を使う（フォームが個別に取得していたときと同じ頻度）
  useEffect(() => {
    // 3 つとも失敗時に例外を投げず undefined を返す
    Promise.all([fetchAdvanceCompany(), fetchSalesPayment(), fetchSalesAccountsReceivable()]).then(
      ([advanceCompanyRes, salesPaymentRes, accountsReceivableRes]) => {
        if (!advanceCompanyRes) return
        setAdvanceCompany(advanceCompanyRes)
        setSalesPayments(salesPaymentRes?.salesPayment ?? [])
        setAccountsReceivableSettings(accountsReceivableRes?.accountsReceivables ?? [])
        setIsMastersLoaded(true)
      },
    )
  }, [])

  return { advanceCompany, salesPayments, accountsReceivableSettings, isMastersLoaded }
}
